module.exports = "/images/avatar-s-3.jpg?7ed1da4ad8611b35f46c43992d08833d";